export default "__VITE_ASSET__cA95tgjH__"